import React, { FC } from 'react';
import { CardNavigationFragment } from '../types/graphqlTypes';
import { Card } from './Card';
import { Grid } from './Grid';
import { Section } from './Section';

interface CardNavigationProps extends CardNavigationFragment {
  width: 'narrow' | 'wide';
}

// JSX

export const CardNavigation: FC<Omit<CardNavigationProps, '__typename'>> = ({ cards, width }) => {
  if (cards.length < 1) {
    return null;
  }

  return (
    <Section contained background="gradient" narrow={width === 'narrow'}>
      <Grid desktopColumns="4">
        {cards.map((card, index) => {
          let heading;
          let text;
          let image;
          let label = 'Explore page';
          let url;

          // Switch out data used depending if page object or custom card
          if (card.page) {
            heading = card.page.pageName;
            text = card.page.feed.shortDescription;
            image = card.page.feed.featuredImage;
            label = card.label ? card.label : 'Explore page';
            url = card.page.relativeUrl;
          } else {
            heading = card.title;
            text = card.text;
            image = card.image;
            url = card.link.url;
            label = card.link.name;
          }
          return (
            <Card
              key={`nav-card-${index}`}
              image={image}
              heading={heading}
              meta={text}
              url={url}
              actionLabel={label}
              backgroundColor="white"
            />
          );
        })}
      </Grid>
    </Section>
  );
};
